/**
 * Desktop Menu (condensado):
 * - Define --distance-to-top para max-height
 * - Fixa colunas aninhadas (2ª/3ª) com position:fixed para o overflow
 *   da coluna pai não cortar nem desativar o scroll
 * Sem portal/proxy — evita loop de MutationObserver.
 */
(function () {
  var MQ = '(min-width: 1000px)';
  var PIN_CLASS = 'maxi-nav-dropdown--pinned';

  function clearPin(el) {
    if (!el) return;
    el.classList.remove(PIN_CLASS);
    el.style.position = '';
    el.style.left = '';
    el.style.right = '';
    el.style.top = '';
    el.style.bottom = '';
  }

  function pinNested(el) {
    var item = el.closest('.nav-dropdown__item');
    if (!item) return;

    var anchor = item.querySelector(':scope > .nav-dropdown__link') || item;
    var rect = anchor.getBoundingClientRect();
    var maxH = Math.max(120, window.innerHeight - 24);
    var top = Math.round(Math.min(Math.max(8, rect.top - 8), maxH - 80));
    var left = Math.round(rect.right);

    // Se não cabe à direita, abre à esquerda
    var approxWidth = Math.max(el.offsetWidth || 0, 220);
    if (left + approxWidth > window.innerWidth - 8) {
      left = Math.max(8, Math.round(rect.left - approxWidth));
    }

    el.classList.add(PIN_CLASS);
    el.style.position = 'fixed';
    el.style.left = left + 'px';
    el.style.top = top + 'px';
    el.style.right = 'auto';
    el.style.bottom = 'auto';
    el.style.setProperty('--distance-to-top', top + 'px');
  }

  function syncDropdown(el) {
    if (!el || !el.getAttribute) return;
    var open = el.getAttribute('aria-hidden') === 'false';
    var parentDropdown = el.parentElement && el.parentElement.closest
      ? el.parentElement.closest('.nav-dropdown')
      : null;

    if (!open) {
      clearPin(el);
      return;
    }

    if (!parentDropdown) {
      // 1ª coluna: sem scroll forçado / sem pin
      clearPin(el);
      el.style.removeProperty('--distance-to-top');
      return;
    }

    // 2ª e 3ª colunas: fixar fora do overflow do pai + scroll
    pinNested(el);
  }

  function init() {
    if (!window.matchMedia(MQ).matches) return;
    if (!('MutationObserver' in window)) return;

    var root = document.querySelector('.header__desktop-nav');
    if (!root) return;

    var dropdowns = root.querySelectorAll('.nav-dropdown');
    dropdowns.forEach(function (el) {
      if (el.getAttribute('aria-hidden') === 'false') syncDropdown(el);
    });

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var el = mutations[i].target;
        if (!el || !el.classList || !el.classList.contains('nav-dropdown')) continue;
        syncDropdown(el);
      }
    });

    dropdowns.forEach(function (el) {
      observer.observe(el, { attributes: true, attributeFilter: ['aria-hidden'] });
    });

    window.addEventListener(
      'resize',
      function () {
        root.querySelectorAll('.nav-dropdown[aria-hidden="false"]').forEach(syncDropdown);
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
